import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-a-textarea',
  templateUrl: './a-textarea.component.html',
  styleUrls: ['./a-textarea.component.scss'],
})
export class ATextAreaComponent implements OnInit {

  @Input() label: string;
  @Input() variable: any;
  @Input() type: any;
  @Input() maxlength: number;
  @Input() minlength: number;
  @Input() icon: string;
  @Input() disabled: boolean;

  @Input() isMandatory: boolean = false;
  @Output() variableChange = new EventEmitter<any>();
  @Output() enterKey = new EventEmitter<string>();

  mandatoryError: string = null;

  constructor(
    public themeservice: ThemeService
  ) { }

  ngOnInit() { }

  editInput() {
    this.variableChange.emit(this.variable);
  }

  checkMandatory() {
    if (this.isMandatory) {
      if (this.type != 'number') {
        if (this.variable == null || this.variable.trim().length == 0) {
          this.mandatoryError = this.label + " is mandatory";
        } else {
          this.mandatoryError = null;
        }
      } else {
        console.log(this.variable);
        if (isNaN(this.variable)) {
          this.mandatoryError = this.label + " is mandatory";
        } else {
          this.mandatoryError = null;
        }
      }
    } else {
      this.mandatoryError = null;
    }
    if (this.type == "email") {
      let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(this.variable)) {
        this.mandatoryError = this.label + ' is not valid';
      }
      else {
        this.mandatoryError = null;
      }
    }
  }

  keyEnter() {
    this.enterKey.emit(this.variable);
  }

  numericOnly(event): boolean { // restrict e,+,-,E characters in  input type number
    if (this.type == "number") {
      const charCode = (event.which) ? event.which : event.keyCode;
      if (charCode == 101 || charCode == 69 || charCode == 45 || charCode == 43) {
        return false;
      }
      return true;
    }

  }

}
